import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import HomePage from './pages/HomePage';
import UserList from './pages/UserList';
import PostCollection from './pages/PostCollection';
import MapPage from './pages/MapPage';
import InfoPage from './pages/InfoPage';

import ShereFeed from './pages/ShereFeed';

import ServiceState from './pages/ServiceStatePage';
import Inquiry from './pages/InquiryPage';
import NgWord from './pages/NgWordPage';
import NgWordCheckerPage from './pages/NgWordCheckerPage';

import Report from './pages/ReportPage';

import FunctionLog from './pages/FunctionLog';
import PremiumSettings from './pages/PremiumSettingsPage';

// import AvatarFrame from './pages/AvatarFramePage';
import AvatarFrameGroupList from './pages/AvatarFrameGroupList';
import AvatarFrameGroupNew from './pages/AvatarFrameGroupNew';
import AvatarFrameGroupEdit from './pages/AvatarFrameGroupEdit';

import Stamp from './pages/StampPage';
import Coupons from './pages/CouponsPage';

import Default from './pages/DefaultPage';

import SystemSetup from './pages/SystemSetupPage';
import RefreshPostsData from './pages/RefreshPostDataPage';

import EntryTestData from './pages/EntryTestData';

import EntrySystemTestData from './pages/EntrySystemTestData';

import PostDetail from './pages/PostDetail';
import UserDetail from './pages/UserDetail';

import CreatePost from './pages/CreatePost';
import XRViewerAuthoringPage from './pages/XRViewerAuthoringPage';

const Management: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" component={HomePage} exact />

        <Route path="/CreatePost" component={CreatePost} exact />
        <Route
          path="/XRViewerAuthoring"
          component={XRViewerAuthoringPage}
          exact
        />

        <Route path="/UserList" component={UserList} exact />
        <Route path="/UserDetail/:id" component={UserDetail} exact />

        <Route path="/PostCollection" component={PostCollection} exact />
        <Route path="/PostDetail/:id" component={PostDetail} exact />
        <Route path="/MapPage" component={MapPage} exact />

        <Route path="/InfoPage" component={InfoPage} exact />

        <Route path="/ShereFeed/:id" component={ShereFeed} exact />
        <Route path="/ShereFeed/" component={ShereFeed} exact />
        <Route path="/SystemSetup" component={SystemSetup} exact />
        <Route path="/RefreshPostsData" component={RefreshPostsData} exact />

        <Route
          path="/EntrySystemTestData"
          component={EntrySystemTestData}
          exact
        />

        <Route path="/EntryTestData" component={EntryTestData} exact />
        <Route path="/ServiceState" component={ServiceState} exact />
        <Route path="/Inquiry" component={Inquiry} exact />
        <Route path="/Report" component={Report} exact />
        <Route path="/NgWord" component={NgWord} exact />
        <Route exact path="/ngwords/checker" component={NgWordCheckerPage} />

        <Route path="/FunctionLog" component={FunctionLog} exact />
        <Route path="/PremiumSettings" component={PremiumSettings} exact />

        <Route
          path="/AvatarFrameGroupList"
          component={AvatarFrameGroupList}
          exact
        />
        <Route
          path="/AvatarFrameGroupNew"
          component={AvatarFrameGroupNew}
          exact
        />
        <Route
          path="/AvatarFrameGroupEdit/:groupId"
          component={AvatarFrameGroupEdit}
          exact
        />

        <Route path="/Stamp" component={Stamp} exact />
        <Route path="/Coupons" component={Coupons} exact />

        <Route path="/Default" component={Default} exact />
      </Switch>
    </Router>
  );
};

export default Management;
